import { mainRoutes } from "./main.routes";
import { registerModule } from "../module.register";

registerModule(() => ({
  name: "main",
  component: () => null,
  routes: mainRoutes,
}));
